import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../services/core/alert.service';
import { ProgressService } from '@shared';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { commonTranslationFallback } from '../services/language/language-preferences';
import { SUPPRESS_GLOBAL_ERROR_FEEDBACK } from './feedback-context';

export function errorInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const progressService = inject(ProgressService);
  const router = inject(Router);
  const injector = inject(Injector);

  progressService.start();

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (!(err instanceof HttpErrorResponse)) {
        return throwError(() => err);
      }

      if (err.status === 401) {
        return throwError(() => err);
      }

      if (err.status === 403) {
        router.navigate(['error/access-denied']);
        return throwError(() => err);
      }

      if (request.context.get(SUPPRESS_GLOBAL_ERROR_FEEDBACK)) {
        return throwError(() => err);
      }

      const alertService = injector.get(AlertService);
      alertService.error(getFeedbackMessage(err));
      return throwError(() => err);
    }),
    finalize(() => progressService.complete())
  );
}

function getFeedbackMessage(error: HttpErrorResponse): string {
  if (error.status === 0) {
    return commonTranslationFallback('connectionError');
  }

  if (error.status >= 500) {
    return commonTranslationFallback('serverError');
  }

  const message = error.error?.message;
  if (typeof message === 'string' && message.trim().length > 0) {
    return message;
  }

  return commonTranslationFallback('genericError');
}
